import { SinglePlayer } from 'components/video/single-video-player'
export default SinglePlayer
